/* eslint-disable jira/integration/test-id-by-folder-structure */
/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { getCollectionViewPageUrl } from '@jira/polaris__component-collections/src/getCollectionsPageUrl.tsx';
import TitleIconResolver from '@jira/polaris__component-view-icon/src/TitleIconResolver.tsx';
import { ExpandableSection } from '@jira/polaris__lib-expandable-section/src/ExpandableSection.tsx';
import { Link } from '@atlassian/react-resource-router';
import type { ViewToDelete } from './ViewToDelete.types.tsx';

const expandableSectionTitle = defineMessage({
	id: 'polaris-component-collection-delete-modal.views-list.expandable-section-title',
	defaultMessage: 'Check the views used in this roadmap',
	description: 'Title of the expandable section in the Delete Roadmap confirmation modal window',
});

const styles = cssMap({
	viewsList: {
		maxHeight: '300px',
		overflowY: 'auto',
		paddingBlock: token('space.0'),
		paddingInline: token('space.0'),
		marginBlock: token('space.0'),
		marginInline: token('space.0'),
	},
	icon: {
		height: '24px',
		width: '24px',
		marginRight: token('space.075'),
	},
	viewTitle: {
		overflowX: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		maxWidth: '500px',
		marginBlock: token('space.0'),
		marginInline: token('space.0'),
	},
});

export const ViewItem = ({
	title,
	emoji,
	kind,
	uuid,
	collectionUUID,
}: ViewToDelete & { collectionUUID: string }): React.JSX.Element => {
	return (
		<Link target="_blank" href={getCollectionViewPageUrl(collectionUUID, uuid)}>
			<Flex alignItems="center">
				<Flex alignItems="center" justifyContent="center" xcss={styles.icon}>
					<TitleIconResolver emojiId={emoji} viewKind={kind} isReadOnly />
				</Flex>
				<Box as="p" xcss={styles.viewTitle}>
					{title}
				</Box>
			</Flex>
		</Link>
	);
};

type Props = {
	collectionUUID: string;
	views: ViewToDelete[];
};

export const ViewsList = ({ collectionUUID, views }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<ExpandableSection
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="polaris-component-collection-delete-modal.ui.views-list.expandable-section"
			title={formatMessage(expandableSectionTitle)}
		>
			<Stack space="space.100" as="ul" xcss={styles.viewsList}>
				{views.map((view) => (
					<ViewItem key={view.uuid} collectionUUID={collectionUUID} {...view} />
				))}
			</Stack>
		</ExpandableSection>
	);
};
